import { render } from "./TeamsContent.vue?vue&type=template&id=adf4e6fe"
import script from "./TeamsContent.vue?vue&type=script&lang=js"
export * from "./TeamsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__